export const KeycloakTypes = {
  GET_USER_DATA: 'GET_USER_DATA',
  SET_USER_PROFILE: 'SET_USER_PROFILE'
};
